import type { SVGProps } from 'react';

const InfoIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        width="31"
        height="17"
        viewBox="0 0 31 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        className={`zone-new-tag ${props.className}`}>
        <rect width="31" height="17" rx="2" fill="none" />
        <path
            d="M9.088 12L5.8 6.012V12H4.84V3.996H5.812L9.052 9.864V3.996H10.012V12H9.088ZM12.6955 12V3.996H16.8115V4.848H13.6555V7.488H16.7275V8.328H13.6555V11.148H16.8115V12H12.6955ZM23.955 12L22.659 5.688L21.363 12H20.343L18.567 3.996H19.599L20.895 10.524L22.263 3.996H23.067L24.423 10.524L25.719 3.996H26.751L24.975 12H23.955Z"
            fill="none"
        />
    </svg>
);

export default InfoIcon;
